import React from 'react';

import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';

import CurrentTariffFinal from './CurrentTariffFinal';
import Final from './Final';

const FinalContainer = (): JSX.Element => {
    const currentTariff = useCtxSelector(state => state.currentTariff);

    if (currentTariff) {
        return <CurrentTariffFinal/>;
    }

    return <Final/>;
};

export default FinalContainer;
